import React, { useState } from 'react';
import './RegulationAdminTT99.css';

const RegulationAdmin = () => {
  const [regulations, setRegulations] = useState([]);
  const [formData, setFormData] = useState({
    date: '',
    department: '',
    description: '',
    file: null, // Updated for file
  });
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, file: e.target.files[0] });
  };

  const handleAddRegulation = () => {
    if (validateForm()) {
      const newRegulation = { ...formData, id: Date.now().toString() };
      setRegulations([...regulations, newRegulation]);
      setFormData({ date: '', department: '', description: '', file: null });
    }
  };

  const handleEditRegulation = (id) => {
    const regulationToEdit = regulations.find((reg) => reg.id === id);
    setFormData({ ...regulationToEdit });
    setIsEditing(true);
    setEditId(id);
  };

  const handleUpdateRegulation = () => {
    if (validateForm()) {
      setRegulations(
        regulations.map((reg) =>
          reg.id === editId ? { ...reg, ...formData } : reg
        )
      );
      setFormData({ date: '', department: '', description: '', file: null });
      setIsEditing(false);
      setEditId(null);
    }
  };

  const handleDeleteRegulation = (id) => {
    setRegulations(regulations.filter((reg) => reg.id !== id));
  };

  const validateForm = () => {
    if (!formData.date || !formData.department || !formData.description || !formData.file) {
      alert('All fields are required, including file upload');
      return false;
    }
    return true;
  };

  return (
    <div className="admin-panelTT99">
      <h2 className="admin-titleTT99">Manage Regulations Table</h2>
      <div className="formTT99">
        <input
          type="text"
          name="date"
          placeholder="Date of Amendment"
          value={formData.date}
          onChange={handleInputChange}
          className="inputTT99"
        />
        <input
          type="text"
          name="department"
          placeholder="Department"
          value={formData.department}
          onChange={handleInputChange}
          className="inputTT99"
        />
        <textarea
          name="description"
          placeholder="Description"
          value={formData.description}
          onChange={handleInputChange}
          className="textareaTT99"
        />
        <input
          type="file"
          name="file"
          onChange={handleFileChange}
          className="file-inputTT99"
        />
        {formData.file && (
          <div className="file-previewTT99">
            <strong>Uploaded File: </strong>{formData.file.name}
          </div>
        )}
        <button onClick={isEditing ? handleUpdateRegulation : handleAddRegulation} className="buttonTT99">
          {isEditing ? 'Update Regulation' : 'Add Regulation'}
        </button>
      </div>

      <table className="tableTT99">
        <thead>
          <tr className="table-rowTT99">
            <th className="table-headerTT99">ID</th>
            <th className="table-headerTT99">Date</th>
            <th className="table-headerTT99">Department</th>
            <th className="table-headerTT99">Description</th>
            <th className="table-headerTT99">File</th>
            <th className="table-headerTT99">Actions</th>
          </tr>
        </thead>
        <tbody>
          {regulations.map((reg) => (
            <tr key={reg.id} className="table-rowTT99">
              <td className="table-cellTT99">{reg.id}</td>
              <td className="table-cellTT99">{reg.date}</td>
              <td className="table-cellTT99">{reg.department}</td>
              <td className="table-cellTT99">{reg.description}</td>
              <td className="table-cellTT99">
                {reg.file ? (
                  <a href={URL.createObjectURL(reg.file)} target="_blank" rel="noopener noreferrer">
                    {reg.file.name}
                  </a>
                ) : (
                  'No file uploaded'
                )}
              </td>
              <td className="table-cellTT99 actionsTT99">
                <button onClick={() => handleEditRegulation(reg.id)} className="edit-btnTT99">Edit</button>
                <button onClick={() => handleDeleteRegulation(reg.id)} className="delete-btnTT99">Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {regulations.length === 0 && (
        <p className="no-dataTT99">No regulations found. Add a new regulation to get started.</p>
      )}
    </div>
  );
};

export default RegulationAdmin;
